import {
  SwiperPagination,
  getSafeUrl,
  useGetSystemDataQuery
} from '@monorepo/shared';
import infoIcon from '../../images/home/new/service/list-icon.svg';
import { server } from '../../config/const';
import { DateTime } from 'luxon';
import { Stack } from 'rsuite';
import serviceTermPdf from '/SD-CloudServices-FortiAnalyzer.pdf';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Mousewheel, Navigation, Autoplay } from 'swiper/modules';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
interface IProps {
  enableMouse: boolean;
  direction: 'horizontal' | 'vertical' | undefined;
}
export const MainSwiper = ({ enableMouse, direction }: IProps) => {
  const { t } = useTranslation();
  const [swiperInstance, setSwiperInstance] = useState<any>(null);
  const [activeIndex, setActiveIndex] = useState<number>(0);
  useEffect(() => {
    if (swiperInstance) {
      const obj = swiperInstance;
      enableMouse ? obj.mousewheel?.enable() : obj.mousewheel?.disable();
    }
  }, [enableMouse]);
  return (
    <Swiper
      onSwiper={(swiper: any) => {
        setSwiperInstance(swiper);
      }}
      autoplay={{
        delay: 8000,
        pauseOnMouseEnter: true
      }}
      style={{ height: '100%', width: '100%' }}
      direction={direction}
      slidesPerView={1}
      spaceBetween={0}
      navigation={true}
      mousewheel={true}
      // pagination={{
      //   clickable: true
      // }}
      // modules={[Mousewheel, Pagination, Navigation, Autoplay]}
      modules={[Mousewheel, Navigation, Autoplay]}
      className="land-swiper"
      onSlideChange={(s: any) => {
        setActiveIndex(s.realIndex);
      }}
    >
      <div className="land-swiper-pager"></div>
      <SwiperSlide>
        <Features />
      </SwiperSlide>
      <SwiperSlide>
        <Service />
      </SwiperSlide>
      <SwiperSlide>
        <Version />
      </SwiperSlide>
      <SwiperPagination total={3} index={activeIndex}></SwiperPagination>
    </Swiper>
  );
};

export const Features = () => {
  const { t } = useTranslation();
  const goToDemo = () => {
    const link = 'https://www.fortinet.com/products/management/fortianalyzer';
    if (window) {
      window.open(getSafeUrl(link), '_blank');
    }
  };
  return (
    <div className="land-feature">
      <div className="feature-list">
        <span className="title">{t('faz.home.features')}</span>
        <p className="feature-info">{t('faz.home.featuresInfo')}</p>
        <div className="feature-chart">
          <div className="chart-text seamless">
            <div className="top-line">{t('faz.home.feature1-1')}</div>
            <div>{t('faz.home.feature1-2')}</div>
          </div>
          <div className="chart-text visibility">
            <div className="top-line">{t('faz.home.feature2-1')}</div>
            <div>{t('faz.home.feature2-2')}</div>
          </div>
          <div className="chart-text realtime">
            <div className="top-line">{t('faz.home.feature3-1')}</div>
            <div>{t('faz.home.feature3-2')}</div>
          </div>
          <div className="chart-text manage">
            <div className="top-line">{t('faz.home.feature4-1')}</div>
            <div>{t('faz.home.feature4-2')}</div>
          </div>
        </div>
        {/* <div className="demo-link" onClick={() => goToDemo()}>
          <div className="chart-text">{t('faz.home.demoLink')}</div>
        </div> */}
      </div>
      <div className="benefit-list">
        <span className="title">{t('faz.home.benefits')}</span>
        <div className="benefit-chart">
          <div className="chart-text first">{t('faz.home.benefit1')}</div>
          <div className="chart-text second">{t('faz.home.benefit2')}</div>
          <div className="chart-text third">{t('faz.home.benefit3')}</div>
          <div className="chart-text fourth">{t('faz.home.benefit4')}</div>
          <div className="chart-text fifth">{t('faz.home.benefit5')}</div>
        </div>
      </div>
    </div>
  );
};
export const Service = () => {
  const { t } = useTranslation();
  const content: Record<string, any>[] = useMemo(
    () => [
      {
        title: t('faz.home.service1'),
        list: [
          t('faz.home.service1-1'),
          t('faz.home.service1-2'),
          t('faz.home.service1-3'),
          t('faz.home.service1-4'),
          t('faz.home.service1-5')
        ]
      },
      {
        title: t('faz.home.service2'),
        list: [
          t('faz.home.service2-1'),
          t('faz.home.service2-2'),
          t('faz.home.service2-3'),
          t('faz.home.service2-4')
        ]
      },
      {
        title: t('faz.home.service3'),
        list: [
          t('faz.home.service3-1'),
          t('faz.home.service3-2'),
          t('faz.home.service3-3')
        ]
      },
      {
        title: t('faz.home.service4'),
        list: [
          t('faz.home.service4-1'),
          t('faz.home.service4-2'),
          t('faz.home.service4-3')
        ]
      }
    ],
    [t]
  );
  return (
    <div className="land-service">
      <div className="title">{t('faz.home.services')}</div>
      <div className="service-content">
        {content.map((item: Record<string, any>, index: number) => (
          <div className="service-section" key={index + 1}>
            <div className="section-title">{item?.title}</div>
            <div className="section-list">
              {item?.list?.map((str: string, idx: number) => (
                <div className="list-info" key={idx + 1}>
                  <img src={infoIcon} className="info-icon" />
                  <div className="info-text">{str}</div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export const Version = () => {
  const { t } = useTranslation();
  const currentYear = DateTime.fromJSDate(new Date()).year;
  const { data: systemData } = useGetSystemDataQuery({
    server: server
  });
  const goToVersion = () => {
    const link =
      'https://docs.fortinet.com/document/fortianalyzer/7.6.0/new-features/731964/overview';
    if (window) {
      window.open(getSafeUrl(link), '_blank');
    }
  };
  return (
    <div className="land-latest-version">
      <div className="title">{t('faz.home.version')}</div>
      <p className="version-info">{t('faz.home.versionInfo')}</p>
      <div className="version-link" onClick={() => goToVersion()}>
        <div className="chart-text">
          {t('faz.home.versionLink', { version: 7.6 })}
        </div>
      </div>
      <Stack className="land-footer" justifyContent="flex-end" spacing={40}>
        <Stack>
          <span>
            {`Copyright © ${currentYear} Fortinet, Inc. All rights reserved.`}
          </span>
        </Stack>
        <Stack spacing={10} alignItems="center" style={{ fontWeight: '700' }}>
          <a href={serviceTermPdf} target="_blank">
            {t('common.footer.termsOfService')}
          </a>
          <span>|</span>
          <a href={systemData?.privacy_url} target="_blank">
            {t('common.footer.privacyPolicy')}
          </a>
          <span>|</span>
          <a href={systemData?.release_note_url} target="_blank">
            {t('common.footer.releaseNotes')}
          </a>
        </Stack>
      </Stack>
    </div>
  );
};
